import { Component, OnInit, Output, EventEmitter } from "@angular/core";
import { ModalService } from "src/app/service/modal-service";
import { SystemService } from "src/app/service/system.service";
import { NotificationService } from "src/app/service/notification-service";
import { GridColumnUserVo } from "src/app/data/grid-column-user-vo";
import { GridColumnUserService } from "src/app/service/grid-column-user.service";

@Component({
  selector: "app-custom-grid-modal",
  templateUrl: "./custom-grid-modal.component.html",
  styleUrls: ["./custom-grid-modal.component.css"],
})
export class CustomGridModalComponent implements OnInit {
  @Output() saveColumnsEvent = new EventEmitter();
  modalId = "custom-grid-column-modal";

  gridColumns = [];
  windowLabel = "Customize Columns";
  gridName = "";
  gridNameDisplay = "";
  lockedNote = "";

  lockedColumns = 2;
  btnMoveUpDisabled = false;
  btnMoveDownDisabled = false;

  selectedItem = null;

  columnNames = [
    "RequestNumber",
    "IncidentNumber",
    "IncidentName",
    "AccountingCode",
    "CostDescription",
    "ItemName",
    "ItemCode",
    "Agency",
    "PaymentAgency",
    "AssignDate",
    "ActualReleaseDate",
    "Status",
    "Remarks",
    "AccrualCode",
    "ResourceName",
    "Trainee",
    "UnitID",
    "ActualReleaseTime",
    "CheckInDate",
    "CheckInTime",
    "NumberPersonnel",
    "DemobCity",
    "DemobState",
    "MobJetPort",
    "MobTravelMethod",
    "MobilizationDate",
    "FirstWorkDay",
    "PlansRemarks",
    "Leader",
    "LeaderName",
    "Other1",
    "Other2",
    "Other3",
    "RequestCategory",
    "LengthAtAssignment",
    "SectionDesc",
    "DemobDate",
    "CellPhoneNumber",
    "CheckoutFormPrinted",
    "RestOvernightRemarks",
    "Deleteable",
    "TentativeReleaseDate",
    "AirTravelToDispatch",
    "EmploymentCode",
    "Agreement",
    "DispNotActualRelease",
    "TentativeReleaseTime",
    "AccrualMix",
    "DispatchNotTentRelease",
    "StrikeTeam",
    "DemobTravelMethod",
    "Archived",
    "ItineraryReceived",
    "TentativeReleaseRemarks",
    "Contracted",
    "UniqueName",
    "Name",
    "EstimatedDateOfArrival",
    "EstimatedTimeOfArrival",
    "SpecialInstructions",
    "CostDescription",
    "DepartFromJetport",
    "NameOnPictureId",
    "AvailableReassignment",
    "TravelMinutes",
    "ContractorName",
    "ActualReleaseRemarks",
    "RestOvernight",
    "TravelHours",
  ];

  columnDisplay = [
    "Request #",
    "Incident #",
    "Incident Name",
    "Accounting Code",
    "Cost Description",
    "Item Name",
    "Item Code",
    "Agency",
    "Payment Agency",
    "Assign Date",
    "Actual Release Date",
    "Status",
    "Remarks",
    "Accrual Code",
    "Resource Name",
    "Trainee",
    "Unit ID",
    "Actual Release Time",
    "Check-In Date",
    "Check-In Time",
    "# Personnel",
    "Demob City",
    "Demob State",
    "Mobilization Jetport",
    "Mobilization Travel Method",
    "Mobilization Date",
    "First Work Day",
    "Plans Remarks",
    "Leader",
    "Leader Name",
    "Other 1",
    "Other 2",
    "Other 3",
    "Request Category",
    "Length of Assignment",
    "Section Description",
    "Demob Date",
    "Cell Phone",
    "Checkout-Form Printed",
    "Rest Overnight Remarks",
    "Deleteable",
    "Tent Release Date",
    "Air Travel To Dispatch",
    "Employment Type",
    "Agreement",
    "Disp Notified Actual Release",
    "Tent Release Time",
    "Accrual Mix",
    "Disp Notified Ten Release",
    "Strike Team",
    "Demobilization Travel Method",
    "Archived",
    "Itinerary Received",
    "Tent Release Remarks",
    "Invoice Setup (OF-286)",
    "Unique Name",
    "Name",
    "Est Arrival Date",
    "Est Arrival Time",
    "Special Instructions",
    "Cost Description",
    "Depart From Jetport",
    "Name on Picture ID",
    "Avail Reassignment",
    "Travel Minutes",
    "Contractor Name",
    "Actual Release Remarks",
    "Rest Overnight",
    "Travel Hours",
  ];

  constructor(
    private modalService: ModalService,
    private systemService: SystemService,
    private gridColumnService: GridColumnUserService,
    private notifyService: NotificationService
  ) {}

  ngOnInit() {}

  getDisplayName(columnName) {
    const idx = this.columnNames.findIndex(
      (r) => r.toUpperCase() === columnName.toUpperCase()
    );
    if (idx > -1) {
      return this.columnDisplay[idx];
    } else {
      return columnName;
    }
  }

  loadWindow() {
    this.gridColumns = [];
    this.selectedItem = null;
    this.btnMoveUpDisabled = true;
    this.btnMoveDownDisabled = true;
    let vos = [];
    if (this.gridName === "RESOURCE") {
      this.lockedNote =
        "NOTE: The first 2 columns are locked and cannot be modified.";
      this.gridNameDisplay = "Check-In";
      vos = this.systemService.userSessionVo
        .gridResourceColumns as GridColumnUserVo[];
    }
    if (this.gridName === "RESOURCEDEMOB") {
      this.lockedNote =
        "NOTE: The first 2 columns are locked and cannot be modified.";
      this.gridNameDisplay = "Demob";
      vos = this.systemService.userSessionVo
        .gridResourceDemobColumns as GridColumnUserVo[];
    }
    if (this.gridName === "RESOURCETIME") {
      this.lockedNote =
        "NOTE: The first 2 columns are locked and cannot be modified.";
      this.gridNameDisplay = "Time";
      vos = this.systemService.userSessionVo
        .gridResourceTimeColumns as GridColumnUserVo[];
    }
    if (this.gridName === "RESOURCECOST") {
      this.lockedNote =
        "NOTE: The first 2 columns are locked and cannot be modified.";
      this.gridNameDisplay = "Cost";
      vos = this.systemService.userSessionVo
        .gridResourceCostColumns as GridColumnUserVo[];
    }
    if (this.gridName === "OTHERCOST") {
      this.lockedNote =
        "NOTE: The first 2 columns are locked and cannot be modified.";
      this.gridNameDisplay = "Other Cost";
      vos = this.systemService.userSessionVo
        .gridOtherCostColumns as GridColumnUserVo[];
    }

    let pos = 1;
    for (let index = 1; index <= vos.length; index++) {
      vos.forEach((v) => {
        if (
          v.position === index &&
          v.gridColumnVo.columnName !== "Archived" &&
          v.gridColumnVo.columnName !== "UniqueName"
        ) {
          // console.log(v.gridColumnVo.columnName + ' ' + v.position);
          const row = {
            id: v.id,
            position: v.position,
            visible: v.visible,
            name: this.getDisplayName(v.gridColumnVo.columnName),
          };

          if ((row.name == "Accrual Code")||(row.name=="Accrual Mix")){
            return
          }
          else{
          this.gridColumns.push(row);
          }
        }
      });
    }
  }

  save() {
    let pos = 1;
    const userId = this.systemService.userSessionVo.userId;
    let vos = [];
    if (this.gridName === "RESOURCE") {
      vos = this.systemService.userSessionVo
        .gridResourceColumns as GridColumnUserVo[];
    }
    if (this.gridName === "RESOURCEDEMOB") {
      vos = this.systemService.userSessionVo
        .gridResourceDemobColumns as GridColumnUserVo[];
    }
    if (this.gridName === "RESOURCETIME") {
      vos = this.systemService.userSessionVo
        .gridResourceTimeColumns as GridColumnUserVo[];
    }
    if (this.gridName === "RESOURCECOST") {
      vos = this.systemService.userSessionVo
        .gridResourceCostColumns as GridColumnUserVo[];
    }
    if (this.gridName === "OTHERCOST") {
      vos = this.systemService.userSessionVo
        .gridOtherCostColumns as GridColumnUserVo[];
    }

    // console.log('saving');
    this.gridColumns.forEach((v) => {
      const idx = vos.findIndex((r) => r.id === v.id);
      if (idx > -1) {
        if (v.name === "Archived") {
          vos[idx].visible = false;
          vos[idx].position = 25;
        } else if (v.name === "UniqueName") {
          vos[idx].visible = false;
          vos[idx].position = 80;
        } else {
          // console.log(v.name + ' ' + v.position);
          vos[idx].visible = v.visible;
          vos[idx].position = v.position;
        }
      }
    });

    vos.forEach((v) => {
      if (v.gridColumnVo.columnName === "UniqueName") {
        v.visible = false;
        v.position = 80;
      }
      if (v.gridColumnVo.columnName === "Archived") {
        v.visible = false;
        v.position = 25;
      }
    });
    this.gridColumnService
      .saveUserGridColumns(userId, this.gridName, vos)
      .subscribe((data) => {
        this.notifyService.inspectResult(data);
        if (data["courseOfActionVo"]["coaName"] === "SAVE_USER_GRID_COLUMNS") {
          // const updatedVos = data['resultObject'] as GridColumnUserVo[];
          switch (this.gridName) {
            case "RESOURCE":
              this.systemService.userSessionVo.gridResourceColumns = vos;
              break;
            case "RESOURCEDEMOB":
              this.systemService.userSessionVo.gridResourceDemobColumns = vos;
              break;
            case "RESOURCETIME":
              this.systemService.userSessionVo.gridResourceTimeColumns = vos;
              break;
            case "RESOURCECOST":
              this.systemService.userSessionVo.gridResourceCostColumns = vos;
              break;
            case "OTHERCOST":
              this.systemService.userSessionVo.gridOtherCostColumns = vos;
              break;
          }

          setTimeout(() => {
            this.loadWindow();
            this.saveColumnsEvent.emit(vos);
          });
        }
      });
  }

  cancel() {
    this.loadWindow();
  }

  moveUp() {
    if (this.selectedItem !== undefined && this.selectedItem !== null) {
      this.swap(this.selectedItem.position, this.selectedItem.position - 1);
    }
  }

  moveDown() {
    if (this.selectedItem !== undefined && this.selectedItem !== null) {
      this.swap(this.selectedItem.position, this.selectedItem.position + 1);
    }
  }

  swap(xPositionToMove: any, yPositionTarget: any) {
    // target object to replace
    let a = this.gridColumns[xPositionToMove - 1];
    a.position = yPositionTarget;

    let b = this.gridColumns[yPositionTarget - 1];
    b.position = xPositionToMove;

    // move selectedItem to yTarget
    this.gridColumns[yPositionTarget - 1] = a;

    this.gridColumns[xPositionToMove - 1] = b;

    setTimeout(() => {
      this.selectedItem = this.gridColumns[yPositionTarget - 1];
      if (this.selectedItem.position - 1 > this.lockedColumns) {
        this.btnMoveUpDisabled = false;
      } else {
        this.btnMoveUpDisabled = true;
      }
      if (this.selectedItem.position + 1 <= this.gridColumns.length) {
        this.btnMoveDownDisabled = false;
      } else {
        this.btnMoveDownDisabled = true;
      }
    });
  }

  onSelectItem(row) {
    this.btnMoveDownDisabled = true;
    this.btnMoveUpDisabled = true;

    // console.log('onSelectItem() row ' + row.name + ' ' + row.position);
    if (row.position > this.lockedColumns) {
      this.selectedItem = row;
      if (row !== undefined && row !== null) {
        if (row.position - 1 > this.lockedColumns) {
          this.btnMoveUpDisabled = false;
        }
        if (row.position + 1 <= this.gridColumns.length) {
          this.btnMoveDownDisabled = false;
        }
      } else {
        this.selectedItem = null;
      }
    } else {
      this.selectedItem = null;
    }
  }

  getCheckboxDisabled(i) {
    if (i + 1 > this.lockedColumns) {
      return false;
    } else {
      return true;
    }
  }

  setItemChecked(pos, evt) {
    this.gridColumns[pos].visible = evt.target.checked;
    this.selectedItem = this.gridColumns[pos];
  }

  openModal() {
    this.modalService.open(this.modalId);
  }

  closeModal() {
    this.modalService.close(this.modalId);
  }
}
